import React from "react";
import { Button } from "components/ui/button";
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
  CardTitle,
  CardDescription,
} from "components/ui/card";

// Adjust the path if your assets folder location differs
import appIcon from "../logo192.png";

const Home = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-4" dir="rtl">
      <Card className="w-full max-w-3xl overflow-hidden border border-border shadow-md">
        {/* One responsive “single card” layout:
            - Mobile: stacked (image above text)
            - Desktop: side-by-side (image right, text left) */}
        <div className="grid grid-cols-1 sm:grid-cols-5">
          {/* Image */}
          <div className="sm:col-span-2 bg-accent/10 flex items-center justify-center p-6">
            <img
              src={appIcon}
              alt="Store Management"
              className="h-28 w-28 sm:h-40 sm:w-40 object-contain drop-shadow"
              draggable="false"
            />
          </div>

          {/* Text */}
          <div className="sm:col-span-3">
            <CardHeader className="pb-3">
              <CardTitle className="text-2xl sm:text-3xl font-bold text-primary">
                ניהול חנות
              </CardTitle>
              <CardDescription className="mt-2 text-muted-foreground">
                מערכת לניהול הזמנות, תגיות, סינון ומיון — בצורה פשוטה, מהירה ונוחה.
              </CardDescription>
            </CardHeader>

            <CardContent className="pt-0">
              <p className="text-sm text-muted-foreground">
                התחילו דרך התפריט העליון, חפשו הזמנות לפי תגיות, וסננו לפי סטטוס ותאריכים.
              </p>
            </CardContent>
        
            {/* <CardFooter className="flex flex-col gap-2 sm:flex-row sm:justify-start">
              <Button size="lg" className="w-full sm:w-auto">
                התחלה
              </Button>
              <Button variant="secondary" size="lg" className="w-full sm:w-auto">
                צפייה בהזמנות
              </Button>
            </CardFooter> */}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Home;
